import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-debug',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <div style="padding: 20px;">
      <h1>{{ 'DASHBOARD.DASHBOARD' | translate }}</h1>
      <h2>{{ 'APIARY.LIST_HEADER' | translate }}</h2>
      <p>{{ 'APIARY.LIST_INTRO' | translate }}</p>
      <p>This is a minimal debug component to test for the NG0600 error.</p>
      <p>Current time: {{ currentTime }}</p>
      <h3>{{ 'LOGGING.FORM.OBSERVATIONS.LABEL' | translate }}</h3>
      <p>Testing various translation keys to ensure ngx-translate works properly.</p>
    </div>
  `
})
export class DebugComponent {
  currentTime = new Date().toISOString();
}